import type { PdfRendererSource } from "../pdf-renderer/pdf-renderer";

/** A document name shown as the file it stands for. */
export function documentFileName(docName: string): string {
  return /\.pdf$/i.test(docName) ? docName : `${docName}.pdf`;
}

export function downloadSource(src: PdfRendererSource, fileName: string): void {
  let href: string;
  let revoke = false;

  if (typeof src === "string") {
    href = src;
  } else if (src instanceof Blob) {
    href = URL.createObjectURL(src);
    revoke = true;
  } else if (src instanceof ArrayBuffer || src instanceof Uint8Array) {
    href = URL.createObjectURL(new Blob([src], { type: "application/pdf" }));
    revoke = true;
  } else if ("url" in src) {
    href = src.url;
  } else {
    href = URL.createObjectURL(
      new Blob([src.buffer], { type: "application/pdf" }),
    );
    revoke = true;
  }

  const anchor = document.createElement("a");
  anchor.href = href;
  anchor.download = fileName;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  if (revoke) {
    window.setTimeout(() => URL.revokeObjectURL(href), 0);
  }
}
